import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenNib, faGlobe, faUserLock } from "@fortawesome/free-solid-svg-icons";

/**
 * Until real classroom stories arrive, we share what we're building toward:
 * features that help teachers maximize student learning without soaking up a
 * ton of their personal time.
 */
const INTENTS: readonly { icon: typeof faPenNib; title: string; body: string }[] = [
  {
    icon: faPenNib,
    title: "Lessons in your own voice",
    body: "Easily create lessons that stay consistent with your own teaching style, so prepping a class feels like minutes, not evenings and weekends.",
  },
  {
    icon: faGlobe,
    title: "Nothing to install",
    body: "Everything runs in the browser your students already use. No downloads, no IT tickets, no devices to set up. Just open a link and teach.",
  },
  {
    icon: faUserLock,
    title: "A private learning space",
    body: "A calm, private space shared just between students and their teacher. It stays focused on learning, free of distractions and outside eyes.",
  },
];

export default function FeatureIntents() {
  return (
    <div className="landing-feature-grid">
      {INTENTS.map((intent) => (
        <article key={intent.title} className="landing-feature">
          <span className="landing-feature-icon" aria-hidden="true">
            <FontAwesomeIcon icon={intent.icon} />
          </span>
          <h3 className="landing-feature-title">{intent.title}</h3>
          <p className="landing-feature-body muted">{intent.body}</p>
        </article>
      ))}
    </div>
  );
}
